define('services/session',[
    'underscore', 'backbone', 'mustache', 'backbone.session', 'utils', 'debug', 'bootbox',
    // services
    'services/api',
    'services/user',
    'services/activity-watcher',
    'services/i18n',
    'services/events/user-events',
    'services/mandatory-questionnaires',
    'services/platform.service'
], function(
    // libs
    _, Backbone, Mustache, BackboneSession, U, DEBUG, Bootbox,
    // services
    API,
    User,
    ActivityWatcher,
    i18n,
    UserEvents,
    MandatoryQuestionnaires,
    PlatformService
) {
    var _callback = _.callback,
        Session;

    var SessionModel = BackboneSession.extend({
        url: "TotalCoaching-Session", // local storage key
        authUrl: "#/auth", // authentication page url
        isExpiredGroupShown: false,

        initialize: function(attrs, options) {
            this.options = options || {};
            this.user = User;
            this.questionnairesIndex = 0;
            this.listenToOnce(UserEvents, "profile:fetchComplete", this.writeTokenCookie);
            //https://app.totalcoaching.dev/#/auth/login/58c1661cbe11042f517f11f3:394f5fa8e6b4ae2945c671a3504f2f56
            //fallback to bypass IOS & Android localStorage bug

            var response = "";
            try {
                response = JSON.parse(window.localStorage.getItem("TotalCoaching-Session"));
            } catch (e) {
                response = "";
            }
            //If localStorage is empty, signin with the cookie token
            if (response === null || _.isEmpty(response.access_token)) {
                this.signInWithCookieToken(); //signIn with the fallback token cookie
            } else {
                this.fetch(); //Normal login process
            }
        },

        showMandatoryQuestionnaires: function() {
            var questionnaires = new MandatoryQuestionnaires({ questionnaires: this.user.get('questionnaires') });
            questionnaires.start();
        },

        signInWithCookieToken: function() {
            //try to get the auth token cookie
            var token = U.getCookieByName("fbTokenTC");
            //If there's no cookie, the normal login process occur
            if (_.isEmpty(token)) {
                this.fetch();
            } else {
                //If a token cookie is found, we must save it to localStorage for the next auto-login
                var userId = token.split(':')[0];
                this.save({
                    access_token: token,
                    user: userId
                });
                //Finally, redirection to the auto-login page with the token found
                var url = window.env.APP_DOMAIN + "#/auth/login/" + token;
                window.location.href = url;
            }

        },
        //This function is called by a trigger in User._onSync after the fetch is completed
        writeTokenCookie: function() {
            var token = this.getToken();
            var userId = token.split(':')[0];
            this.save({
                access_token: token,
                user: userId
            });
            document.cookie = "fbTokenTC=" + token;

            //Needed to update the last login date un DB
            var requestParam = Mustache.render("?username={{{username}}}&client_id={{{client_id}}}", {
                    username: encodeURIComponent(User.get("email")),
                    client_id: "testclientid",
                });

            this.showMandatoryQuestionnaires();

            return Backbone.ajax(
                _.extend({
                    url: API.url("oauth2/setLastLoginDate") + requestParam,
                    method: "GET",
                    context: this,
                }, {
                    success: function(response, textStatus, xhr) {
                    },
                })
            );

        },

        signIn: function(username, password, options) {
            options = options || {};
            var session = this;
            this.trigger('before:signin', this);
            return Backbone.ajax(
                _.extend({
                    url: API.url("oauth2/token"),
                    method: "POST",
                    dataType: "json",
                    data: {
                        username: username,
                        password: password,
                        grant_type: "password",
                        client_id: "testclientid"
                    },
                }, options, {
                    beforeSend: function(jqXHR) {
                        if (DEBUG) jqXHR.setRequestHeader("x-debug", true);
                        _callback(this, options.beforeSend, [jqXHR]);
                    },
                    success: function(response, textStatus, jqXHR) {
                        session.useToken(response.access_token);
                        _callback(this, options.success, arguments);
                        session.trigger("signin:success", session, response);
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        _callback(this, options.error, arguments);
                        session.trigger("signin:error", session, jqXHR);
                    }
                })
            );

        },

        signOut: function(options) {
            options = options || {};
            var session = this,
                superSignOut = SessionModel.__super__.signOut;
            this.trigger('before:signout', this);

            U.deleteCookieByName("fbTokenTC");

            var revokeToken = PlatformService.isNative() ? true : false;

            var url = API.url("oauth2/logout");

            if (PlatformService.isNative()) {
                url = API.url("oauth2/logout?revokeFirebaseToken")
            }

            // Revoke firebase web token if the user logs out
            if (PlatformService.isWeb() && this.user.get('firebaseWebToken')) {
                url = API.url("oauth2/logout?revokeFirebaseWebToken");
            }

            return Backbone.ajax(
                _.extend({
                    url: url,
                    method: "POST",
                }, options, {

                    beforeSend: function(jqXHR) {
                        _callback(this, options.beforeSend, arguments);
                    },
                    success: function(response, textStatus, jqXHR) {
                        superSignOut.call(session, options);
                        if (!options.noRedirect) {
                            _callback(this, options.success, arguments);
                            session.trigger("signout:success", session);
                            if (ActivityWatcher.isRunning()) {
                                ActivityWatcher.stop();
                            }
                            session.redirectAfterSignOut();
                        }
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        _callback(this, options.error, arguments);
                        session.trigger("signout:error", session, jqXHR);
                        if (jqXHR.status === 401) {
                            superSignOut.call(session, options);
                            session.redirect();
                        }
                    }
                })
            );
        },

        getAuthStatus: function(options) {
            options = options || {};
            var session = this,
                success = options.success;
            return User.fetch(_.extend({}, options, {
                success: function(model, response, options) {
                    _callback(this, success, [session, true, options]);
                },
            }));
        },

        onUnauthorized: function() {
            U.deleteCookieByName("fbTokenTC");
            this.destroy(); // clear storage
            this.clear(); // clear model attributes
            this.trigger('unauthorized');
            this.redirect();
        },

        isAuthenticated: function() {
            return this.has('access_token');
        },

        getToken: function() {
            return this.get('access_token');
        },

        useToken: function(token, options) {
            if (!token) this.onUnauthorized();
            var userId = token.split(':')[0];

            var promise = this.save({
                access_token: token,
                user: userId
            }, options);
            User.fetch({ force: true });
            return promise;
        },

        getUserId: function() {
            return this.get('user');
        },

        redirect: function() {
            Backbone.history.redirect(this.authUrl);
            //var logoutUrl = window.env.OLD_ORIGIN + 'public/login.php';
            //window.location.href = logoutUrl;

        },

        redirectAfterSignOut: function() {
            var logoutUrl = User.getMainGroup().logoutUrl;

            if (PlatformService.isNative() || !logoutUrl) return this.redirect();

            window.location.href = logoutUrl;
        },

        isBootboxDisplayed: function() {
            return this.BootboxDisplayed;
        },

        setBootboxDisplayedStatus: function(value) {
            this.BootboxDisplayed = value;
        },

    });

    Session = new SessionModel();

    /**
     * oauth2 enable backbone sync hook
     */
    Backbone.sync = (function(syncFn) {
        return function(method, model, options) {
            options = options || {};

            var beforeSend = options.beforeSend,
                error = options.error;

            _.extend(options, {
                // Add auth headers
                beforeSend: function(xhr) {
                    if (beforeSend) return beforeSend.apply(this, arguments);
                },
                // handle unauthorized error (401)
                error: function(xhr, textStatus, errorThrown) {
                    window.Rollbar.error("Backbone.sync in session.js\n" + "textStatus: " + JSON.stringify(textStatus), errorThrown);
                    if (error) error.call(options.context, xhr, textStatus, errorThrown);
                    if (xhr.status === 401) {
                        Session.onUnauthorized();
                    }
                }
            });

            return syncFn.call(this, method, model, options);
        };
    })(Backbone.sync);

    return Session;
});

